// @ts-expect-error import from /public/ folder
import logo from '/logo.svg?url&raw';
import styled from '@emotion/styled';

import { useBackground } from '~/modules/elements/background-context';
import { EurovisionTheme } from '~/modules/elements/layout-with-background';
import Logo from '~/modules/elements/logo';
import { colorSets } from '~/modules/game-engine/drawing/styles';
import LayoutGame from '~/routes/layout-game';
import eurovisionIcon from '~/routes/sing-a-song/song-selection/components/song-card/eurovision-icon.svg';
import EurovisionBgSvg from '~/routes/social-media-elements/eurovision-background';

export default function SocialMediaElements() {
  useBackground(false);

  return (
    <LayoutGame>
      <LogoContainer>
        <IconLogo dangerouslySetInnerHTML={{ __html: logo }} />
        <ESCBarsLogo>
          <EurovisionTheme />
        </ESCBarsLogo>
      </LogoContainer>
      <BackgroundPhoto>
        <ESCBarsBackground>
          <EurovisionTheme />
        </ESCBarsBackground>
        <Logo />
        {/*<ChristmasTree>🎁</ChristmasTree>*/}
        <EurovisionLogo src={eurovisionIcon} alt="Eurovision" />
      </BackgroundPhoto>
      <EurovisionBgSvg />
    </LayoutGame>
  );
}

const LogoContainer = styled.div`
  width: 400px;
  aspect-ratio: 1/1;
  position: relative;
  padding: 30px;
  //background: #222222;
`;

const ESCBarsLogo = styled.div`
  display: flex;
  position: absolute;
  inset: 0;
  z-index: -1;

  div {
    background-image: linear-gradient(
      0deg,
      ${colorSets.eurovisionViolet.text},
      ${colorSets.eurovisionBlue.text},
      ${colorSets.eurovisionGreen.text},
      ${colorSets.eurovisionBlue.text},
      ${colorSets.eurovisionViolet.text}
    );
  }
`;

const IconLogo = styled.svg`
  width: 400px;
  aspect-ratio: 1/1;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgb(0 0 0 / 0.6));

  path:nth-of-type(1) {
    fill: ${colorSets.red.text} !important;
  }
  path:nth-of-type(2) {
    fill: ${colorSets.blue.text} !important;
  }
`;

const ESCBarsBackground = styled(ESCBarsLogo)`
  div {
    background-image: linear-gradient(
      0deg,
      ${colorSets.eurovisionPink.text},
      ${colorSets.eurovisionRed.text},
      ${colorSets.eurovisionGreen.text},
      ${colorSets.eurovisionPink.text}
    );
  }
`;

const BackgroundPhoto = styled.div`
  overflow: hidden;
  position: relative;
  height: calc(693px / 1);
  width: calc(2048px / 1);
  transform: scale(1);

  background-color: black;
  background-image: linear-gradient(
    120deg,
    ${colorSets.red.stroke},
    ${colorSets.red.hit.fill} 49.9%,
    ${colorSets.blue.hit.fill} 50.1%,
    ${colorSets.blue.stroke}
  );
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    //margin-bottom: 160px;

    //video:nth-of-type(1) {
    //  width: 800px;
    //  height: 300px;
    //  object-fit: contain;
    //}

    //img:nth-of-type(1) {
    //  transform: translate(-0px, 80px);
    //  width: 180px;
    //  height: 80px;
    //  object-fit: contain;
    //}
  }
`;

const EurovisionLogo = styled.img`
  margin-left: 4rem;
  transform: scale(1.5);
`;
